<template>
    <group-report-template  v-model:for-group="forGroup"
                            v-model:interval="$data._interval"
                            v-model:reload-data="$data._reloadTable"
                            report-name="system-health-report"
                            v-model:running-errors="$data._errorSending"
                            v-model:ran-report="$data._reportSuccessfullySent"
                            v-model:running-report="$data._runningReport"
                            v-model:current-report-template-id="currentReportTemplateId"
                            v-model:settings="$data._settings"
                            v-model:display-section="displaySection"
                            v-model:users="users"
                            :can-edit="permissions.can('manage_system_health_report')"
                            :default-settings="defaultSettings"
                            @useStandardReporting="setUseStandardReporting"
    >
        <template   #create-settings>
          <system-health-report-settings
                v-model:interval="$data._interval"
                v-model:settings="$data._settings"
                :is-savable="false"
            ></system-health-report-settings>
        </template>

        <template   #edit-settings>
          <system-health-report-settings
            v-model:interval="$data._interval"
            v-model:settings="$data._settings"
            :is-savable="displaySection === 'show-template' || useStandardReporting"
          ></system-health-report-settings>
        </template>

        <template   #run-options>
          <div v-if="displaySection === 'show-template'"
               class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
            <label for="showHealthChecks">Show Health Checks in Report</label>
            <toggle
              id="showHealthChecks"
              v-model:value="$data._settings['show_health_checks']"
              name="showHealthChecks">
            </toggle>
          </div>

          <!--          Battery Checks -->
          <div v-if="displaySection === 'show-template'"
               class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
            <label for="showBatteryChecks">Show Battery Checks in Report</label>
            <toggle
              id="showBatteryChecks"
              v-model:value="$data._settings['show_battery_checks']"
              name="showBatteryChecks">
            </toggle>
          </div>

          <!--            Calibration Checks -->
          <div v-if="displaySection === 'show-template'"
               class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
            <label for="showCalibrationChecks">Show Calibration Checks in Report</label>
            <toggle
              id="showCalibrationChecks"
              v-model:value="$data._settings['show_calibration_checks']"
              name="showCalibrationChecks">
            </toggle>
          </div>

          <div class="flex justify-center">
            <button v-if="isRunning"
                    class="col-span-2 w-full lg:w-2/3 my-4 relative inline-flex items-center justify-center
                        px-4 py-2 border border-transparent text-sm bg-blue-600 text-white font-medium
                        rounded opacity-50 cursor-not-allowed">
              <span class="lnr icon-loading animate-spin mr-3"></span>
              Running Report, Please Wait
            </button>
            <button v-else
                    class="col-span-2 w-full lg:w-2/3 my-4 relative inline-flex items-center justify-center px-4 py-2 border
                        border-transparent text-sm leading-5 font-medium rounded-md text-white bg-blue-600
                        hover:bg-blue-500 focus:outline-none focus:ring-blue-200 focus:border-blue-700
                        active:bg-blue-700"
                    @click="runReport($data._reportTemplateId)">
              Run Report
            </button>
          </div>
        </template>
    </group-report-template>
</template>

<script>
import axios from "axios"
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {ajaxTableMixin} from "@/mixins/ajaxTableMixin";
import ReportHomeModal from "./ReportHomeModal";
import ButtonBlueSecondary from "../elements/buttons/ButtonBlueSecondary";
import BaseReport from "../Reports/BaseReport";
import MeterIntervalSelection from "./MeterIntervalSelection";
import AjaxTable from "../elements/AjaxTable";
import Select2 from "../elements/select2";
import SlideOverPanel from "../elements/SlideOverPanel";
import ButtonRedSecondary from "../elements/buttons/ButtonRedSecondary";
import ButtonGreenPrimary from "../elements/buttons/ButtonGreenPrimary";
import GroupReportTemplate from "./GroupReportTemplate";
import SystemHealthReportSettings from "@/components/GroupReports/SystemHealthReportSettings.vue";
import Toggle from "@/components/elements/toggle.vue";

export default {
    name: "GroupSystemHealthReport",
    mixins: [SonicuCoreMixin, ajaxTableMixin],
    components: {
      Toggle,
      SystemHealthReportSettings,
        GroupReportTemplate,
        ButtonGreenPrimary,
        ButtonRedSecondary,
        SlideOverPanel,
        AjaxTable,
        MeterIntervalSelection, BaseReport, ReportHomeModal, ButtonBlueSecondary, Select2,
        Menu, MenuButton, MenuItem, MenuItems,
    },
    props: {
        receiveWeekday: {
            type: Number,
            default: 1,
        },
        interval: {
            type: String,
            default: 'monthly',
        },
        meters: {
            type: Object,
            default() {
                return {}
            },
        },
        users: {
            type: Object,
            default() {
                return {}
            }
        },
        defaultSettings: {
            type: Object,
            default() {
                return {}
            }
        },
    },
    data() {
        return {
            displaySection: null,

            // Manual Run Stuff
            _interval: this.interval,
            endOfInterval: new Date(),
            _templateName: '',
            _groupId: null,

            _data: [],

            _reloadTable: false,
            _settings: this.defaultSettings,
            _runningReport: false,
            _reportSuccessfullySent: false,
            _errorSending: [],

            currentReportTemplateId: null,
            forGroup: false,
            isRunning: false,

            useStandardReporting: false,
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        runReport(reportTemplateId = null) {
            console.log(`Running report on System Health Report file w/ reportTemplateIndex: ${reportTemplateId}`)
            let params = {}
            if (reportTemplateId !== null) {
                params['reportTemplateId'] = reportTemplateId
                params['forGroup'] = this.forGroup
            }
            else {
                params['interval'] = this.$data._interval
            }

          params['show_health_checks'] = this.$data._settings['show_health_checks']
          params['show_battery_checks'] = this.$data._settings['show_battery_checks']
          params['show_calibration_checks'] = this.$data._settings['show_calibration_checks']

            // return
            this.$data._runningReport = true
            axios.post(this.company.buildCompanyRoute('group-reports/system-health-report'), params)
                .then(response => {
                    let data = response.data
                    console.log(`Report Queued successfully, data is`)
                    console.log(data)
                    // Clear the error logs, since the report is done.
                    this.$data._reportSuccessfullySent = true
                    this.$data._errorSending = []
                })
                .catch(response => {
                    let data = response.data
                    console.log(`Report Queued Failed, data is`)
                    console.log(data)
                    // Store the logs from errors to show.
                    this.$data._errorSending = data
                })
                .finally(() => {
                    console.log(`Report finalizing`)
                    // Finish the sending of the report.
                    this.$data._runningReport = false
                })
        },
        resetTemplateRun() {
            this.currentReportTemplateIndex = null
            this.forGroup = false
        },
        setUseStandardReporting(event) {
            this.useStandardReporting = event
        }
    },
    computed: {},
    watch: {
    },
}
</script>

<style scoped>

</style>